<template>
  <div class="application-modal-wrapper">
    <div @click="onModalApplicationShow('erstellen', 'massnahme')" class="custom-button" v-intro="'<strong>Neues Gesuch erfassen</strong><br><br>Klicken Sie auf das Pluszeichen und es öffnet sich eine Eingabemaske. Wählen Sie dort die gewünschte Fördermassnahme aus, die Sie einreichen möchten. Für ein bestimmtes Gebäude oder eine weitere Massnahme in einer Gemeinde. Wählen Sie die Gemeinde aus der Liste oder erfassen Sie die genaue Adresse des Gebäudes, in dem Sie auf das Pluszeichen <span>Neues Gebäude</span> klicken.'" v-intro-step="5" v-intro-position="'right'">
      <div class="button-box-body">
        <a class="icon-lg rounded-circle">
          <span class="icon-add"></span>
        </a>
      </div>
      <div class="button-legend">Neues Gesuch</div>
    </div>
    <b-modal v-model="modalShow" show size="xl" ref="application-modal" id="application-modal" no-close-on-backdrop hide-footer @hidden="onCloseApplicationModal">
      <gesuch-form />
      <template v-slot:modal-header>
        <div class="modal-background"></div>
      </template>
      <template v-slot:default="{ close }">
        <b-button variant="light" @click="close" class="modal-close">×</b-button>
        <application-form-wrapper />
      </template>
    </b-modal>

    <property-add-form-wrapper />

    <!--- Modal Person Create -->
    <person-add-form-wrapper :isContactPerson="false" id="modal-multi-person" />

    <!--- Modal Person Create -->
    <person-add-form-wrapper :isContactPerson="true" id="modal-multi-person-contact" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'
  import ApplicationFormWrapper from '@/components/application/ApplicationFormWrapper.vue'
  import PropertyAddFormWrapper from '@/components/application/Intro/PropertyActions/PropertyAddFormWrapper.vue'
  import PersonAddFormWrapper from '@/components/application/Person/PersonAddFormWrapper.vue'

  export default {
    async created () {
      window.addEventListener('beforeunload', this.leaving)
      const { modalMethod, tabName, draftId } = this.$route.params

      if (modalMethod && modalMethod === 'erstellen') {
        this.onModalApplicationShow(modalMethod, 'massnahme')
      } else if (modalMethod && modalMethod === 'bearbeiten') {
        await this.editDraft(draftId)
        this.onModalApplicationShow(modalMethod, tabName, draftId)
      }
    },
    mounted () {
      this.$root.$on('applicationModalComponent', () => {
        this.$refs['application-modal'].hide()
      })
      this.$root.$on('applicationModalClose', () => {
        this.onResetApplicationModal()
      })
    },
    methods: {
      onModalApplicationShow (modalMethod, tabName, draftId) {
        this.$store.commit('application/SET_MODAL_SHOW', {
          boolShow: true,
          modalMethod,
          tabName,
          draftId
        })
      },
      onResetApplicationModal () {
        this.$store.commit('application/RESET_APPLICATION_FORM')
        this.$store.commit('application/SET_MODAL_SHOW', {
          boolShow: false,
          modalMethod: null
        })
      },
      onCloseApplicationModal () {
        this.setApplicationFormDirty()
        const { modalMethod } = this.$route.params

        if (modalMethod === 'erstellen' && this.isFormDirty) {
          this.$bvModal.msgBoxConfirm('Möchten Sie die Änderungen als Entwurf speichern?', {
            title: 'Ungespeicherte Änderungen',
            buttonSize: 'md',
            okVariant: 'primary',
            cancelVariant: 'secondary',
            okTitle: 'Ja',
            cancelTitle: 'Nein',
            hideHeaderClose: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true
          })
            .then(value => {
              if (value) {
                this.hasUnknownError = false
                this.hasError = false

                this.$store.dispatch('draft/SAVE_DRAFT').then(res => {
                  const { errors } = res

                  if (errors) {
                    return errorHandler(this, errors)
                  }
                }).catch(err => {
                  this.hasUnknownError = true
                  this.unknownErrorMessage = this.$t('formError.unknownwError')
                  console.error(err)
                })
              }
            })
            .catch(() => {})
            .finally(() => {
              this.onResetApplicationModal()
            })
        } else if (modalMethod === 'bearbeiten') {
          const { draftId } = this.$route.params

          this.hasUnknownError = false
          this.hasError = false

          this.$store.dispatch('draft/UPDATE_DRAFT', draftId).then(res => {
            const { errors } = res

            if (errors) {
              return errorHandler(this, errors)
            }
          })
            .catch(err => {
              this.hasUnknownError = true
              this.unknownErrorMessage = this.$t('formError.unknownwError')
              console.error(err)
            })
            .finally(() => {
              this.onResetApplicationModal()
            })
        } else {
          this.$router
            .push({
              name: 'uebersicht'
            })
            .catch(() => {})
        }
      },
      async editDraft (draftId) {
        this.hasUnknownError = false

        try {
          this.hasUnknownError = false
          this.hasError = false

          const { errors } = await this.$store.dispatch('draft/GET_DRAFT_BY_ID', draftId)

          if (errors) {
            return errorHandler(this, errors)
          }
        } catch (err) {
          this.hasUnknownError = true
          console.error(err)
        }
      },
      leaving () {
        console.log('leavePage') // TODO: Prevent Page Reload
      },
      setApplicationFormDirty () {
        this.$store.commit('application/SET_APPLICATION_FORM_DIRTY')
      }
    },
    computed: {
      ...mapState({
        isFormDirty: state => state.application.isFormDirty
      }),
      modalShow: {
        set (value) {
          this.$store.state.application.modalShow = value
        },
        get () {
          return this.$store.state.application.modalShow
        }
      }
    },
    watch: {
      async $route (to, from) {
        const { tabName } = to.params

        if (!tabName) {
          this.onResetApplicationModal()
        }
      }
    },
    components: {
      ApplicationFormWrapper,
      PropertyAddFormWrapper,
      PersonAddFormWrapper
    }
  }
</script>

<style lang="scss" scoped>
  #application-modal{
    .modal-header{
      padding: 0;
    }
    .modal-background{
      background: assets('gesuch-header.jpg') no-repeat top left;
      background-size: cover;
      height: 100px;
      width: 100%;
    }
    .modal-close{
      position: absolute;
      right: 0;
      top: 0;
      font-size: x-large;
      padding: 0 1rem;
      background: none;
      border: none;
      font-weight: 700;
      opacity: 0.5;

      &:hover, &:active, &:focus{
        background: none !important;
        border: none !important;
        opacity: 0.75;
      }
    }
    .petition-dialog::v-deep{
      .el-dialog__header{
        padding: 0;
      }

      .el-dialog__headerbtn{
        position: absolute;
        top: 120px;
        font-size: 25px;
      }
      .el-step__head.is-finish{
        color: $magenta;
        border-color: $magenta;
      }
      .el-step__title.is-finish{
        color: $magenta;
      }
      .el-step__description{
        color: $black-60;
      }
    }
  }
</style>
